import React, { useEffect, useState } from "react";
import { CircularProgress, Box } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { tipTransfer } from "../apis";

const TipPaymentSuccess = () => {
  const navigate = useNavigate();
  let { id, amount } = useParams();

  useEffect(() => {
    const setTip = async () => {
      const data = await tipTransfer({
        serviceProviderId: id,
        amount: amount,
      });
      if (data.data.success == true) {
        navigate("/");
      }
    };
    setTip();
  }, []);
  return (
    <Box
      sx={{ display: "flex" }}
      justifyContent="center"
      alignItems="center"
      style={{ height: "100vh" }}
    >
      <CircularProgress disableShrink />
    </Box>
  );
};

export default TipPaymentSuccess;
